var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid",class:[`grid--${_vm.col}`, { 'grid--indent': _vm.indent, 'grid--revers-mobile': _vm.revers_mobile }]},_vm._l((_vm.arr),function(item){return _c('div',{key:item,staticClass:"grid__item"},[_vm._t(`item-${item}`)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }